import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.map";
import React from 'react';
import PropTypes from 'prop-types';
import CmsAccordion from '../../utils/cms-accordion/CmsAccordion';
import CmsContent from '../../CmsContent';
import useDevice from '../../../hooks/use-device';
import EnhancedTabsDesktop from './EnhancedTabsDesktop';
export var EnhancedTabs = function EnhancedTabs(_ref) {
  var data = _ref.data;
  var device = useDevice();

  var _ref2 = data || {},
      _ref2$component = _ref2.component;

  _ref2$component = _ref2$component === void 0 ? {} : _ref2$component;
  var metadata = _ref2$component.metadata,
      _ref2$component$conte = _ref2$component.content;
  _ref2$component$conte = _ref2$component$conte === void 0 ? {} : _ref2$component$conte;
  var tabs = _ref2$component$conte.tabs;
  var tabExist = tabs && Array.isArray(tabs) && tabs.length;
  return device.isMobile() ? /*#__PURE__*/React.createElement(React.Fragment, null, tabExist ? tabs.map(function (content, index) {
    var _ref3 = content || {},
        title = _ref3.title,
        text = _ref3.text;

    return /*#__PURE__*/React.createElement(CmsAccordion, {
      key: index,
      title: /*#__PURE__*/React.createElement(CmsContent, {
        content: title
      }),
      content: /*#__PURE__*/React.createElement(CmsContent, {
        content: text
      })
    });
  }) : null) : /*#__PURE__*/React.createElement(EnhancedTabsDesktop, {
    metadata: metadata,
    tabs: tabs,
    tabExist: tabExist
  });
};
EnhancedTabs.propTypes = {
  data: PropTypes.object.isRequired
};
export default EnhancedTabs;